import { getBookIdWithPrefix } from "@/shared/utils/content/content";
import { getBaseHost } from "@/shared/utils/url/url";
import { NEXT_URLS } from "./routes.constants";
import {
  ReaderQueryParam
} from "@/components/Reader/Panel.constants";

export const makeChapterUrl = (idOrIds, activeIndex = 0, isObject) => {
  const pathname = NEXT_URLS.read + "/" + (Array.isArray(idOrIds) ? idOrIds[0] : idOrIds);

  let query = "";
  if (Array.isArray(idOrIds) && idOrIds[1]) {
    query =
      ReaderQueryParam.panelSecond + "=" + idOrIds[1]
      + "&" + ReaderQueryParam.indexPanelActive + "=" + activeIndex;
  }

  if (isObject) {
    return {pathname, query};
  }

  return pathname + (query ? ("?" + query) : "");
};

export const makeBookUrl = (id) => {
  return NEXT_URLS.bookInfo + "/" + getBookIdWithPrefix(id);
};

export const makeShareChapterUrl = (basePath, id) => {
  return getBaseHost() + basePath + NEXT_URLS.read + "/" + id;
};
